<template>
  <div v-if="images">
    <van-popup v-model="visible" position="top" class="HideScrollbar">
      <div class="main">
        <h1>
          <el-button class="back" type="text" icon="el-icon-back" @click="onCancel" />
          選擇圖片
        </h1>
        {{ obj.id }}
        <!-- <van-radio-group v-model="result"> -->
        <!-- x{{ result }}x -->
        <van-grid>
          <van-grid-item v-for="r in images" :key="r" @click="pick(r)">
            <div v-if="used(r)" class="used"></div>
            <!-- <i v-if="used(r)" class="el-icon-circle-check icon "></i> -->

            <!-- v-bind:class="used(r) ? used : ''" -->
            <!-- <van-radio :name="r" /> -->
            <div class="img" v-bind:style="imgUrl(r)"></div>
            <van-image :src="r" radius="0.5rem" fit="fill" lazy-load> </van-image>

            <!-- <div v-if="used(r)">{{ used(r) }}</div> -->
          </van-grid-item>
        </van-grid>
        <!-- </van-radio-group> -->
      </div>
    </van-popup>
  </div>
</template>

<style scoped>
.img {
  /* background-image: url(../../assets/cloud.png); */
  /* background-image: url('http://localhost:8080/images/1.png'); */
  background-size: 100px;
  background-repeat: no-repeat;
  height: 5rem;
  width: 100px;
  line-height: 4rem;
  text-align: center;
  font-size: 0.8rem;
  overflow: hidden;
  position: absolute;
}
.back {
  font-size: 2rem;
}
.used {
  background-color: rgba(1, 1, 1, 0.6);
  position: absolute;
  width: 99%;
  height: 99%;
  z-index: 10;
  margin:0.5%;
}
.van-image {
  position: absolute;
  /* width: 5rem; */
  margin: 1rem;
}
.van-grid-item {
  height: 20rem;
}
.van-popup {
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  height: 100%;
}
.main {
  text-align: left;
  padding: 1rem;
}
</style>

<script>
export default {
  data() {
    return {
      visible: false,
      images: null,
      columns: [],
      result: null,
      obj: null,
      bkmenu: null,
    };
  },
  methods: {
    onCancel() {
      this.visible = false;
    },
    async init() {
      var res = await this.apiGetBKMenu();
      this.bkmenu = res.data;
    },
    used(src) {
      try {
        var extitem = this.bkmenu.extitem;
        if (extitem == null || extitem == undefined) {
          return false;
        }
        var find = extitem.find((r) => r.imgfile == src);
        if (find) {
          return true;
        }
        return false;
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    async show(obj) {
      this.init();
      var res = await this.apiGetImages();
      this.images = res.data;
      this.result = "";
      this.images = this.images.map((r) => {
        return this.$path.join("upload", r);
      });
      this.obj = obj;
      this.visible = true;
    },

    pick(url) {
      this.result = url;
      this.$emit("pick", this.obj, url);
      this.visible = false;
    },
    imgUrl(obj) {
      var id = obj.id;
      if (id == this.$store.state.typeid) {
        id += "c";
      }
      var output = { "background-image": "url('images/" + id + ".png')" };
      return output;
    },
  },
};
</script>
